export default "__VITE_ASSET__C6$45H1U__"